import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, ResponseResult } from 'vnpost-shared';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommissionsForSaleService extends BaseService {
  constructor(http: HttpClient, injector: Injector) {
    super(
      http,
      injector,
      `${environment.apiDomain.llbJavaEndpoint}/salesChannel`
    );
  }
  // token = 'YmUwYTk4MjUxNGE3NWEwYTliYjhjZDFkZGVhMGFhNzQ3ZTg1YzlhZjM1MmMwMmNjYjRmYTRiNzYzNzEyMGNhYw'; // Replace with your token

  getListCommissionsForSale(model): Promise<any> {
    const apiUrl = `${this.serviceUri}/getAll?search=${
      model?.code ?? ''
    }&pageNo=${model?.pageNo ?? ''}&pageSize=${model?.pageSize ?? ''}`;
    return this._http
      .get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  getCommissionsForSaleDetail(id: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/detail/${id}`;
    return this._http
      .get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  create(model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/create`;
    return this._http
      .post<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  update(id: any, model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/update/${id}`;
    return this._http
      .put<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  inactive(id: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/inActive/${id}`;
    return this._http
      .put<any>(apiUrl, {})
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  getAllByUnitCode(code): Promise<any> {
    const apiUrl = `${this.serviceUri}/GetAllByUnitCode?unitCode=${code ?? ''}`;
    return this._http
      .get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
}
